import { useContext } from "react";
import { SummerSchoolSparkContext } from "../contexts/summerSchoolSparkContext";

const useSummerSchoolSparkContext = () => useContext(SummerSchoolSparkContext);

export { useSummerSchoolSparkContext };
